import { productsByLang, Product } from "./product";

// International track of the same program: English content, priced in AED, paid via Stripe.
const base = productsByLang.en;

export const productIntl: Product = {
  ...base,
  price: 4200,
  currency: "AED",
  depositAmount: 4200,
  remainingAmount: 0,
  installmentOptions: [1],
  priceNote: "Price shown is in AED. Payment is processed securely via Stripe.",
  heroImage: "/egitim2.jpeg",
  galleryImages: ["/egitim2.jpeg"],
};
